import {
  toSectionCtaSingle,
  toSectionFeature,
  toSectionSlider
} from '@/lib/transformers'
import { SectionCtaSingle, SectionFeature, SectionSlider } from '@/ui/Sections'
import SpotSanityList from '@/ui/components/SpotSanity/Layouts/SpotSanityListStory'

import { Typo3SectionSpotSanityPressroom } from '@/types/typo3'
import { memo, Suspense } from 'react'
import Detail from './Layouts/Detail'

interface Props {
  data: Typo3SectionSpotSanityPressroom
}

const SpotSanityPressroom = ({ data }: Props) => {
  const layout = data?.plugin?.layout

  switch (layout) {
    case 'horizontal-with-images': {
      const sectionData = toSectionFeature(
        data as Typo3SectionSpotSanityPressroom
      )
      return <SectionFeature {...sectionData} variant="story" />
    }
    case 'photo-big': {
      const sectionData = toSectionCtaSingle(data)
      return <SectionCtaSingle {...sectionData} variant="story" />
    }
    case 'photo-big-slide': {
      const sectionData = toSectionSlider(data)
      return <SectionSlider {...sectionData} />
    }
    case 'detail': {
      return <Detail data={data} />
    }
    default: {
      return (
        <Suspense>
          <SpotSanityList data={data} storeType={'pressroom'} />
        </Suspense>
      )
    }
  }
}

export default memo(SpotSanityPressroom)
